import script from "./home-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./home-header.vue?vue&type=script&lang=ts&setup=true"

import "./home-header.vue?vue&type=style&index=0&id=58d3d7f2&lang=scss"

const __exports__ = script;

export default __exports__